import {
  balanceSheetColumnDefinition,
  countryCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  descriptionColumnDefinition,
  enabledFlagColumnDefinition,
  overrideTaxRateColumnDefinition,
  plAccountColumnDefinition,
  taxCurrencyColumnDefinition,
  taxRateColumnDefinition,
  deferredTaxRateColumnDefinition,
  deferredPlAccountColumnDefinition,
  deferredBsAccountColumnDefinition,
  overrideDeferredTaxRateColumnDefinition,
} from '../columnDefinitions';

export const calcSettingsTaxRatesColumnDefs = [
  { ...descriptionColumnDefinition, headerName: 'Country Tax Type' },
  taxCurrencyColumnDefinition,
  taxRateColumnDefinition,
  { ...overrideTaxRateColumnDefinition, minWidth: 135 },
  { ...balanceSheetColumnDefinition, headerName: 'Current Balance Sheet', minWidth: 135 },
  { ...plAccountColumnDefinition, headerName: 'Current P&L' },
  deferredTaxRateColumnDefinition,
  overrideDeferredTaxRateColumnDefinition,
  deferredPlAccountColumnDefinition,
  deferredBsAccountColumnDefinition,
];

export default [
  countryTaxTypeColumnDefinition,
  countryCodeColumnDefinition,
  enabledFlagColumnDefinition,
  descriptionColumnDefinition,
  taxRateColumnDefinition,
  { ...plAccountColumnDefinition, headerName: 'Current P&L' },
  { ...balanceSheetColumnDefinition, headerName: 'Current BS' },
  deferredTaxRateColumnDefinition,
  deferredPlAccountColumnDefinition,
  deferredBsAccountColumnDefinition,
];
